import React, {type JSX} from 'react';
import {Box, Button} from '@mui/material';
import {InfoIcon} from '../../../assets/icons/infoIcon';
import Description from '../description';
import {ViewFileWrapper} from './viewerWrapper';

type Props = {
  title?: string;
  description?: string;
  onRetry?: () => void;
};

export function ViewerScreenError({
  title,
  description,
  onRetry,
}: Readonly<Props>): JSX.Element {
  return (
    <ViewFileWrapper>
      <Box
        sx={theme => ({
          backgroundColor: theme.palette.grey['100'],
          color: theme.palette.primary.main,
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          marginBottom: theme.spacing(3),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <InfoIcon style={{width: '30px', height: '30px'}} />
      </Box>
      <Description isError title={title} description={description} />
      {onRetry ? (
        <Button
          onClick={e => {
            e.stopPropagation();
            onRetry();
          }}
          data-testid="error-screen-upload-retry-button"
          size="presizedSmall"
          variant="outlined"
        >
          Retry
        </Button>
      ) : null}
    </ViewFileWrapper>
  );
}
